<template>
  <v-app>
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="toTop"
        title="Back To Top"
        class="back-to-top-button">
        <v-icon small>fas fa-chevron-up fa-2x</v-icon>
      </v-btn>
    </v-fab-transition>
    <navigation></navigation>
    <cookie-banner></cookie-banner>
    <v-main class="main-wrapper">
      <router-view></router-view>
    </v-main>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Navigation from '@/components/navbars/Navigation.vue';
import CookieBanner from '@/components/CookieBanner.vue';
import { useAppStore } from '@/store/AppStore'

export default {
  name: "MainWebsiteApp",
  components: {
    Footer,
    Navigation,
    CookieBanner
  },
  setup () {
    const appStore = useAppStore();
    return { appStore };
  },
  data() {
    return {
      fab: false,
    };
  },
  mounted() {
    this.appStore.fetchMaintenanceData();
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 2000;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style>
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--v-backdrop-base);
}

.back-to-top-button {
  bottom: 82px !important;
  right: 8px !important;
  width: 60px !important;
  height: 60px !important
}
</style>
